// extracted by mini-css-extract-plugin
module.exports = {"root":"pagination-button_root__GSyuu","disabled":"pagination-button_disabled__yjTyP"};